import { CONVERSION_FACTORS, MATERIAL_CONSTANTS } from '../constants/calculator_constants';

export type TensionResult = {
  kpsi: number;
  gpa: number;
  strainPercent: number;
};

export function computeTensionFromGrams(
  grams: number,
  diameterMicrons: number,
  youngsModulus = MATERIAL_CONSTANTS.E0_MPA
): TensionResult {
  const forceNewtons = (grams * CONVERSION_FACTORS.GRAVITY) / 1000; // convert grams to Newtons
  const radiusMeters = ((diameterMicrons / 1000000)) / 2;
  const areaMeters2 = Math.PI * radiusMeters * radiusMeters;
  const stressPa = forceNewtons / areaMeters2;
  const stressGPaLocal = stressPa / 1e9;
  const stressKpsiLocal = stressGPaLocal / CONVERSION_FACTORS.KSI_TO_GPA;
  const strainLocal = stressGPaLocal / (youngsModulus) * 100000;

  return {
    kpsi: stressKpsiLocal,
    gpa: stressGPaLocal,
    strainPercent: strainLocal,
  };
}

export default computeTensionFromGrams;